import { Box, Typography } from "@mui/material";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import CustomizedButton from "../../../components/Custom/CustomizedButton";
import AgGrid from "../../../components/Table/AgGrid";
import { getAllRoles } from "../../../features/User/Rbac/rbac-action";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { usePermission } from "../../../hooks/use-auth";

const Rbac = () => {
  const dispatch = useDispatch();
  const gridRef = useRef();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { createPermission } = usePermission();

  const breadcrumbs = [
    {
      name: t("user.index"),
      to: "/user",
    },
    {
      name: t("user.rbac.index"),
    },
  ];

  const columnDefs = [
    {
      field: "document_id",
      headerName: t("user.rbac.roleId"),
      filter: "agTextColumnFilter",
    },
    {
      field: "name",
      headerName: t("user.rbac.name"),
      filter: "agTextColumnFilter",
    },
    {
      field: "description",
      headerName: t("user.rbac.description"),
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("user.rbac.totalUser"),
      filter: "agNumberColumnFilter",
      valueGetter: (params) => params.data.employee_list.length,
    },
  ];

  const datasource = {
    getRows(params) {
      const request = params.request;
      dispatch(
        getAllRoles(
          {
            startRow: request.startRow,
            endRow: request.endRow,
            filterModel: request.filterModel,
            sortModel: request.sortModel,
          },
          params,
          enqueueSnackbar
        )
      );
    },
  };

  const onGridReady = (params) => {
    const allColumnIds = [];
    params.columnApi.getAllColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params.columnApi.autoSizeColumns(allColumnIds, false);
    params.api.setServerSideDatasource(datasource);
  };

  const onRowDoubleClicked = (e) => {
    navigate(
      `${pathname}/${e.data.document_id}?step=permission&subtab=inventory`
    );
  };

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h5">{t("user.rbac.index")}</Typography>
        {createPermission && (
          <CustomizedButton
            title={t("user.rbac.addNewRole")}
            variant="contained"
            onClick={() =>
              navigate(`${pathname}/add?step=permission&subtab=inventory`)
            }
          />
        )}
      </Box>
      <Box sx={{ mt: "2rem" }}>
        <AgGrid
          ref={gridRef}
          columnDefs={columnDefs}
          height={649}
          onGridReady={onGridReady}
          onRowDoubleClicked={onRowDoubleClicked}
          rowSelection={"multiple"}
          enableRangeSelection={true}
        />
      </Box>
    </>
  );
};

export default Rbac;
